import React from 'react';
import useSizeClass from 'hooks/use-size-class';
import dynamic from 'next/dynamic';

import type { PriceHistoryRowProps } from './types';

const PriceHistoryRowDesktop = dynamic(() => import('./PriceHistoryRow.desktop'), {
  loading: () => <div>Loading...</div>,
});

const PriceHistoryRowMobile = dynamic(() => import('./PriceHistoryRow.mobile'), {
  loading: () => <div>Loading...</div>,
});


export default function PriceHistoryRow({ listing, isBlurred, isCurrentListing, testId, onContactForPriceClick, onViewListingClick }: PriceHistoryRowProps) {
  const isMobile = useSizeClass({ max: 1000 });
  return isMobile ? (
    <PriceHistoryRowMobile listing={listing} isBlurred={isBlurred} isCurrentListing={isCurrentListing} testId={testId} onContactForPriceClick={onContactForPriceClick} onViewListingClick={onViewListingClick} />
  ) : (
    <PriceHistoryRowDesktop listing={listing} isBlurred={isBlurred} isCurrentListing={isCurrentListing} testId={testId} onContactForPriceClick={onContactForPriceClick} onViewListingClick={onViewListingClick} />
  );
}
